module.exports = __webpack_public_path__ + "static/media/SpeedOrderScreen.0f3c81fc.png";